import styled from "@emotion/styled";
export const StyledAiExpandableBundle = styled.div`
  display: flex;
  flex-direction: column;
  background-color: #ffffff;
  border-radius: 8px;
  position: relative;

  &::before {
    content: "";
    position: absolute;
    inset: 0;
    border-radius: 8px;
    padding: 1px;
    background: conic-gradient(
      from 180deg at 50% 50%,
      rgb(129, 129, 255) 16%,
      rgb(51, 219, 219) 42%,
      rgb(51, 213, 142) 53%,
      rgb(255, 214, 51) 64%,
      rgb(252, 82, 125) 86%,
      rgb(129, 129, 255) 100%
    );
    -webkit-mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    -webkit-mask-composite: xor;
    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
    mask-composite: exclude;
    pointer-events: none;
    opacity: 1;
  }

  .bundle-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 12px;
    transition: padding 0.3s ease;
    cursor: pointer;
    background-color: #EDF1FC;
    border-radius: 8px 8px 0 0;
  }

  .bundle-header-left {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .bundle-header-title {
    font-size: 14px;
    font-weight: 500;
    line-height: 150%;
  }

  .bundle-chevron {
    transition: transform 0.2s ease;
    display: flex;
    align-items: center;

    &.chevron-expanded {
      transform: rotate(180deg);
    }
  }

  .bundle-content-wrapper {
    display: grid;
    grid-template-rows: 0fr;
    transition: grid-template-rows 0.3s ease;

    &.content-expanded {
      grid-template-rows: 1fr;
    }
  }

  .bundle-content-overflow {
    overflow: hidden;

    &.fully-expanded {
      overflow: visible;
    }
  }

  .bundle-content {
    background-color: #ffffff;
    border-radius: 0 0 8px 8px;
    padding: 16px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 16px;
  }

  .bundle-content-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    width: 100%;
  }

  .bundle-text-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 4px;
    width: 100%;
  }

  .bundle-heading {
    font-size: 24px;
    font-weight: 500;
    line-height: 30px;
    color: #323338;
    text-align: center;
    margin: 0;
  }

  .bundle-subtitle {
    font-size: 16px;
    font-weight: 400;
    line-height: 22px;
    color: #5559df;
    text-align: center;
  }

  .bundle-description {
    font-size: 14px;
    font-weight: 400;
    line-height: 20px;
    text-align: center;
    color: #323338;
  }

  .bundle-product-logos {
    display: flex;
    justify-content: center;
    gap: 24px;
    flex-wrap: nowrap;
    max-width: 100%;
  }

  .bundle-product-logo-icon {
    width: 53px;
    height: 63px;
    flex-shrink: 0;
    position: relative;

    img {
      width: 100%;
      height: 100%;
    }

    .bundle-tooltip {
      display: none;
      position: absolute;
      bottom: calc(100% + 12px);
      left: 50%;
      transform: translateX(-50%);
      width: 240px;
      padding: 14px;
      background-color: #323338;
      color: #fff;
      font-size: 13px;
      text-align: center;
      white-space: normal;
      border-radius: 8px;
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
      z-index: 999;

      &::after {
        content: "";
        position: absolute;
        left: 50%;
        transform: translateX(-50%);
        bottom: -10px;
        border-style: solid;
        border-width: 10px 10px 0 10px;
        border-color: #323338 transparent transparent transparent;
      }
    }

    &:hover .bundle-tooltip {
      display: block;
    }
  }
`;
